import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const STORAGE_KEY = 'oauth-result-linkedin';

function broadcastResult(data: Record<string, unknown>) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function LinkedInOAuthCallback() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Connecting your LinkedIn account...');

  useEffect(() => {
    const connected = searchParams.get('connected');

    if (connected === 'true') {
      setStatus('success');
      setMessage('LinkedIn account connected successfully!');
      broadcastResult({ type: 'linkedin-oauth', success: true });
      setTimeout(() => window.close(), 1500);
    } else {
      setStatus('error');
      setMessage('LinkedIn connection failed. Please try again.');
      broadcastResult({ type: 'linkedin-oauth', success: false, error: 'Connection failed' });
      setTimeout(() => window.close(), 3000);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-[#1875FF] animate-spin mx-auto mb-4" />
            <h2 className="text-2xl font-extrabold text-gray-800 mb-2 font-display">
              Connecting LinkedIn
            </h2>
            <p className="text-gray-600">{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <h2 className="text-2xl font-extrabold text-gray-800 mb-2 font-display">
              Success!
            </h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">This window will close automatically...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
            <h2 className="text-2xl font-extrabold text-gray-800 mb-2 font-display">
              Connection Failed
            </h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-4">This window will close automatically...</p>
          </>
        )}
      </div>
    </div>
  );
}
